<kendo-dialog title="{{title | translate}}" *ngIf="opened" (close)="opened=!opened" [minWidth]="250" [width]="450">
    <p style="margin: 30px; text-align: center;" [innerHtml]="content"></p>
    <kendo-dialog-actions>
        <button kendoButton (click)="opened=!opened" translate>{{cancelText | translate}}</button>
        <button kendoButton (click)="onConfirmButtonClicked()" themeColor="primary" translate> {{confirmText | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>